export type ErrorMessagesType = {
  INVITATION_EXPIRED: string;
  INVITATION_CANCELLED: string;
  ACCESS_DENIED_INVITATION: string;
  PARTIE_NON_TROUVÉE: string;
  CLIENT_NOT_IN_ROOM: string;
  ROUND_NOT_INITIALIZED: string;
  VALIDATION_FAILED: string;
  FAILED_TO_CREATE_ROUND: string;
  WAIT_OTHER_PLAYER: string;
  ROOM_NOT_FOUND: string;
  NEW_POINT_INSIDE_POLYGONE: string;
  PARAMETER_PLAYERS_ROUND_NOT_FOUND: string;
  USER_NOT_AUTHENTICATED: string;
  PLAYER_NOT_EXIST: string;
  HAVE_ROUND_IN_PROGRESS: string;
  ACCESS_DENIED_ROOM: string;
  FAILED_TO_UPDATE: string;
  TRANSACTION_FAILED: string;
  PLAYER_HAVE_ROUND_IN_PROGRESS: string;
  NOT_TURN_OF_USER: string;
  ROOM_FULL: string;
  SERVER_DRAINING: string;
};

export const ErrorMessages: ErrorMessagesType = {
  INVITATION_EXPIRED: 'Cette invitation a expiré.',
  INVITATION_CANCELLED: 'Invitation annulée.',
  ACCESS_DENIED_INVITATION: 'Vous ne pouvez pas rejoindre cette invitation.',
  PARTIE_NON_TROUVÉE: 'Partie non trouvée',
  CLIENT_NOT_IN_ROOM: 'Vous n’êtes pas dans une salle',
  ROUND_NOT_INITIALIZED: 'La partie n’est pas initialisée',
  VALIDATION_FAILED: 'La validation a échoué',
  FAILED_TO_CREATE_ROUND: 'Échec de la création de la manche',
  WAIT_OTHER_PLAYER: 'Il faut attendre un autre joueur pour jouer',
  ROOM_NOT_FOUND: 'Partie non trouvée',
  NEW_POINT_INSIDE_POLYGONE:
    "Vous ne pouvez pas ajouter votre point à l'intérieur !",
  PARAMETER_PLAYERS_ROUND_NOT_FOUND:
    'Les paramètres des joueurs pour cette manche sont introuvables',
  USER_NOT_AUTHENTICATED: 'Utilisateur non authentifié',
  PLAYER_NOT_EXIST: "Le joueur n'existe pas",
  HAVE_ROUND_IN_PROGRESS: 'Vous avez une partie en cours',
  ACCESS_DENIED_ROOM:
    "Vous n'avez pas l'autorisation d'accéder à cette partie.",
  FAILED_TO_UPDATE: "Une erreur c'est produite lors de la transaction",
  TRANSACTION_FAILED: "Une erreur c'est produite lors de la transaction",
  PLAYER_HAVE_ROUND_IN_PROGRESS:
    'Ce jouer a une partie en cours, veillez reesayer plus tard',
  NOT_TURN_OF_USER: "Ce n'est pas votre tour de jouer !",
  ROOM_FULL: 'Cette partie est déjà complète.',
  SERVER_DRAINING: 'Mise à jour du serveur en cours, réessayez dans quelques minutes.',
};
